import { t } from './translations';
import { eventBus } from './event-bus';
import { getChatConfig } from './chat-config-utils';
import { WindowType } from '../../types/global-window-type';

declare const window: WindowType;
let bannerCache = { bannerPageURls: {} };

export const enableEnhancedPreChat = () => {
  const pageURL = window.location.href;

  return pageURL.includes(t('helpCenter')) && !pageURL.includes(t('order-help-v2'));
};

let isStudioErrorPage = false;

// TODO
export const studioErrorPageHandle = (data) => {
  console.info('Studio Error Page', data);
  isStudioErrorPage = true;
};
eventBus.on('studioErrorPage', (data) => studioErrorPageHandle(data));

export const hideChatOnToolBar = (data) => {
  const customButton = document.getElementById('caHelpButton');
  if (customButton != null && customButton.classList.contains('caHelpButtonEnabled')) {
    customButton.style.visibility = data ? 'hidden' : 'visible';
  }
};

eventBus.on('hideChatChip', (data) => hideChatOnToolBar(data));

export const initiateOHChat = async (data) => {
  console.info('initiateOHChat', data?.isOrderHelpPage, data?.description, data?.orderNumber);

  sessionStorage.setItem('miaw_order_help_description', data?.description);

  window.embeddedservice_bootstrap?.prechatAPI?.setHiddenPrechatFields({
    orderNumber: data?.orderNumber || '',
  });

  eventBus.dispatch('onCAButtonClicked', data);
};

export const isStudioPage = () => {
  const path = window.location.pathname;
  if (path.includes(t('studio')) && !isStudioErrorPage) {
    const { locale } = getChatConfig();

    const allowedLocales = [
      'en-us',
      'en-gb',
      'en-ie',
      'en-ca',
      'en-au',
      'en-nz',
      'en-sg',
      'da-dk',
      'de-at',
      'de-ch',
      'de-de',
      'es-es',
      'es-us',
      'fi-fi',
      'fr-be',
      'fr-ca',
      'fr-ch',
      'fr-fr',
      'it-ch',
      'it-it',
      'nb-no',
      'sv-se',
      'nl-nl',
      'nl-be',
    ];
    if (locale && allowedLocales.includes(locale)) return true;
    return false;
  }
  return false;
};

export const isProjectsPage = () => {
  const path = window.location.pathname;
  if (path.includes(t('my-account-projects'))) return true;
  return false;
};

export const isHelpCenterHomepage = () => {
  const path = window.location.pathname;
  const url = window.location.href;
  if (path === t('helpCenterHomepage')) return true;
  if (url.includes('help-center-page.care-staging.vpsvc.com')) return true;
  return false;
};

export const isPPAGLearnPage = () => {
  const pageURL = window.location.href;
  if (pageURL.includes('discover-and-learn')) return true;
  return false;
};

export async function isBannerPage() {
  try {
    if (Object.keys(bannerCache.bannerPageURls).length === 0 || !bannerCache || !bannerCache.bannerPageURls) {
      try {
        const response = await fetch('https://caretech-ux-mods-prod.s3.amazonaws.com/bannerPages.json');
        const data = await response.json();
        bannerCache = data;
      } catch (error) {
        console.error(error);
        bannerCache = { bannerPageURls: {} };
      }
    }

    console.info('Banner Cache', bannerCache);
    const currentURL = window.location.href;
    let matchedStyle = null;
    let allowed = false;

    if (bannerCache && bannerCache.bannerPageURls && Object.keys(bannerCache.bannerPageURls).length) {
      const allUrlsArray = Object.keys(bannerCache.bannerPageURls);
      allUrlsArray.forEach((url) => {
        const endPath = currentURL?.split('/')?.pop();
        console.info('End path', endPath);
        if (endPath && endPath.includes(url)) {
          matchedStyle = bannerCache.bannerPageURls[url];
          allowed = true;
        }
      });

      return { allowed, matchedStyle };
    }

    return false;
  } catch (error) {
    console.error('Error checking chat allowance:', error);
    return false;
  }
}

export const isDiscoveryPage = () => {
  const isClothingBagsPage = window.location.href.includes(t('clothingBags'));
  const isPromotionalProductPage = window.location.href.includes(t('promotionalProduct'));
  return isClothingBagsPage || isPromotionalProductPage;
};

export const isOrderHelpPage = () => window.location.href.includes(t('order-help-v2'));
